export default __webpack_public_path__ + "static/media/logo.f4603e12.png";